import api from '@/api'

export const fetchSignedURLs = config => {
  return api.post(`/upload/aws/s3/create`, config).then(response => response.data)
}

export const completeUploadRequest = data => {
  return api.post(`/upload/aws/s3/complete`, data).then(response => response.data)
}

export const abortUploadRequest = data => {
  return api.post(`/upload/aws/s3/abort`, data).then(response => response.data)
}
